<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">
    <section id="header">
      <h1 class="h1Header">INFORMACIÓN DE TU CUENTA</h1>
    </section>


    <form [formGroup]="editarAdmForm" (ngSubmit)="saveChanges(editarAdmForm.value)">
      <div>
        <mat-card>
          <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
            <div fxFlex="50">
              <mat-form-field appearance="outline">
                <mat-label>Nombre</mat-label>
                <input type="text" matInput formControlName="dsName">
                <mat-error *ngIf="editarAdmForm.controls['dsName'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
                <mat-error *ngIf="editarAdmForm.controls['dsName'].hasError('cannotContainSpace')">
                  El nombre no puede ser un espacio en blanco
                </mat-error>
                <mat-error *ngIf="editarAdmForm.controls['dsName'].hasError('maxlength')">
                  Nombre demasiado largo
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="50">
              <mat-form-field appearance="outline">
                <mat-label>Correo Electrónico</mat-label>
                <input type="email" matInput formControlName="dsEmail">
                <mat-error *ngIf="editarAdmForm.controls['dsEmail'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
                <mat-error *ngIf="editarAdmForm.controls['dsEmail'].hasError('pattern')">
                  Formato de email incorrecto
                </mat-error>
                <mat-error *ngIf="editarAdmForm.controls['dsEmail'].hasError('maxlength')">
                  Email demasiado largo
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
            <div fxFlex="50">
              <mat-form-field appearance="outline">
                <mat-label>Nombre de Usuario</mat-label>
                <input type="text" matInput formControlName="dsUsername">
                <mat-error *ngIf="editarAdmForm.controls['dsUsername'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
                <mat-error *ngIf="editarAdmForm.controls['dsUsername'].hasError('maxlength')">
                  Nombre demasiado largo
                </mat-error>
                <mat-error *ngIf="editarAdmForm.controls['dsUsername'].hasError('cannotContainSpace')">
                  El nombre de usuario no puede ser un espacio en blanco
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="40">
              <mat-form-field appearance="outline">
                <mat-label>Logo</mat-label>
                <ngx-mat-file-input formControlName="logo" accept=".png, .jpg, .jpeg">
                </ngx-mat-file-input>
              </mat-form-field>
            </div>
            <div fxFlex="10" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
              <img class="image-preview" [src]="DsImage" />
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
            <div fxFlex="50">
              <mat-form-field appearance="outline">
                <mat-label>Moneda</mat-label>
                <input type="text" matInput formControlName="dsCurrency" placeholder="ej: $, £, €">
                <mat-error *ngIf="editarAdmForm.controls['dsCurrency'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
                <mat-error *ngIf="editarAdmForm.controls['dsCurrency'].hasError('cannotContainSpace')">
                  La moneda no puede ser un espacio en blanco
                </mat-error>
                <mat-error *ngIf="editarAdmForm.controls['dsCurrency'].hasError('maxlength')">
                  Campo moneda demasiado largo
                </mat-error>
                <mat-error *ngIf="editarAdmForm.controls['dsCurrency'].hasError('pattern')">
                  No puede ingresar números
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="50">
              <mat-form-field appearance="outline">
                <mat-label>API de SMS</mat-label>
                <input type="text" matInput formControlName="dsSmsApi">
                <mat-error *ngIf="editarAdmForm.controls['dsSmsApi'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
                <mat-error *ngIf="editarAdmForm.controls['dsSmsApi'].hasError('cannotContainSpace')">
                  El API no puede ser un espacio en blanco
                </mat-error>
                <mat-error *ngIf="editarAdmForm.controls['dsSmsApi'].hasError('maxlength')">
                  Campo API de SMS demasiado largo
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>
      <div>
        <h2 class="cardHeader">Link de Redes Sociales</h2>
        <mat-card>
          <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
            <div fxFlex="50">
              <mat-form-field appearance="outline">
                <mat-label>Facebook</mat-label>
                <input type="text" matInput formControlName="dsFb">
              </mat-form-field>
            </div>
            <div fxFlex="50">
              <mat-form-field appearance="outline">
                <mat-label>Instagram</mat-label>
                <input type="text" matInput formControlName="dsInsta">
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
            <div fxFlex="50">
              <mat-form-field appearance="outline">
                <mat-label>Twitter</mat-label>
                <input type="text" matInput formControlName="dsTwitter">
              </mat-form-field>
            </div>
            <div fxFlex="50">
              <mat-form-field appearance="outline">
                <mat-label>Youtube</mat-label>
                <input type="text" matInput formControlName="dsYoutube">
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>

      <div>
        <h2 class="cardHeader">Contraseña de Confirmación</h2>
        <mat-card>
          <mat-form-field appearance="outline">
            <mat-label>Contraseña Actual</mat-label>
            <input type="password" matInput formControlName="dsPassword">
            <mat-error *ngIf="editarAdmForm.controls['dsPassword'].hasError('required')">
              Este campo es obligatorio
            </mat-error>
          </mat-form-field>
        </mat-card>
      </div>
      <br>
      <div fxLayout="row" fxLayoutAlign="start center">
        <button type="submit" mat-raised-button [disabled]="!editarAdmForm.valid" class="save-changes">GUARDAR
          CAMBIOS</button>
        <button routerLink="/admin-home" mat-raised-button class="cancel-changes">CANCELAR</button>
      </div>
    </form>
  </div>
</div>